import type { SearchMenuListProps } from "./types-list";
import { useSearchMenuList } from "./use-list";
import { SearchMenuListView } from "./view-list";

export function SearchMenuList(props: SearchMenuListProps) {
  const viewModel = useSearchMenuList(props);

  return <SearchMenuListView {...viewModel} />;
}
SearchMenuList.displayName = "SearchMenu.List";
